module.exports = __webpack_public_path__ + "static/media/icon-finearts.aeea1980.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/icon-finearts.svg
// module id = 988
// module chunks = 0